import { FC, ReactNode } from 'react'
import { Suspense } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { Provider } from 'react-redux'
import { SnackbarProvider } from 'notistack'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'

import { StompSessionProvider } from '@containers/StompSessionProvider/StompSessionProvider'

import { ErrorFallback } from '@components/ErrorFallback'
import { NotistackSnackbar } from '@components/NotistackSnackbar'

import { store } from '@redux/store'

import { AuthProvider } from '@providers/AuthProvider'
import { ThemeProvider } from '@providers/ThemeProvider'

import {
  MAXIMUM_SNACKBARS,
  NOTISTACK_SNACKBAR_DEFAULT_POSITION,
  SNACK_LIFETIME,
  URLS,
} from '@constants'

interface AppProvidersProps {
  children: ReactNode
}

export const AppProviders: FC<AppProvidersProps> = ({ children }) => {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Suspense fallback='loading'>
        <Provider store={store}>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <AuthProvider>
              <StompSessionProvider url={URLS.WS_URL}>
                <ThemeProvider>
                  <SnackbarProvider
                    anchorOrigin={NOTISTACK_SNACKBAR_DEFAULT_POSITION}
                    autoHideDuration={SNACK_LIFETIME}
                    maxSnack={MAXIMUM_SNACKBARS}
                    Components={{
                      default: NotistackSnackbar,
                      success: NotistackSnackbar,
                      error: NotistackSnackbar,
                      warning: NotistackSnackbar,
                      info: NotistackSnackbar,
                    }}
                  >
                    {children}
                  </SnackbarProvider>
                </ThemeProvider>
              </StompSessionProvider>
            </AuthProvider>
          </LocalizationProvider>
        </Provider>
      </Suspense>
    </ErrorBoundary>
  )
}
